(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  // your javascript code here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-tabs"] && !Shopify.designMode) return;
  try {
    
  let answers = document.querySelectorAll('.ing-tabs-inner');

  var i;

  for (i = 0; i < answers.length; i++) {
    answers[i].addEventListener('click', function () { 
      this.classList.toggle('active');
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }

  /*
  answers.forEach((event) => {
    event.addEventListener('click', function () {
      let src = document.getElementById('toggle-icon').src;
      if (src.indexOf('plus-01.svg') != -1) {
        document.getElementById('toggle-icon').src = './Icon.svg';
        document.getElementById('ingredients-tab-content').style.display = 'block';
      } else {
        document.getElementById('toggle-icon').src = './plus-01.svg';
        document.getElementById('ingredients-tab-content').style.display = 'none';
      }
    });
  });
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["no-bitterness"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var button1 = document.getElementById('button1');
    var button2 = document.getElementById('button2');
    var button3 = document.getElementById('button3');
    var button4 = document.getElementById('button4');
    var actualheading = document.getElementById('actualheading');
    var heading1 = document.getElementById('heading1');
    var heading2 = document.getElementById('heading2');
    var heading3 = document.getElementById('heading3');
    var heading4 = document.getElementById('heading4');

    button1.classList.add('btnactive');

    button1.addEventListener('click', function () {
      actualheading.textContent = heading1.textContent;
      this.classList.add('btnactive');
      button2.classList.remove('btnactive');
      button3.classList.remove('btnactive');
      button4.classList.remove('btnactive');
    });
    button2.addEventListener('click', function () {
      actualheading.textContent = heading2.textContent;
      this.classList.add('btnactive');
      button1.classList.remove('btnactive');
      button3.classList.remove('btnactive');
      button4.classList.remove('btnactive');
    });
    button3.addEventListener('click', function () {
      actualheading.textContent = heading3.textContent;
      this.classList.add('btnactive');
      button1.classList.remove('btnactive');
      button2.classList.remove('btnactive');
      button4.classList.remove('btnactive');
    });
    button4.addEventListener('click', function () {
      actualheading.textContent = heading4.textContent;
      this.classList.add('btnactive');
      button1.classList.remove('btnactive');
      button2.classList.remove('btnactive');
      button3.classList.remove('btnactive');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["still-got-question"] && !Shopify.designMode) return;
  try {
    
  var coll = document.getElementsByClassName('collapsible');
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener('click', function () {
      this.classList.toggle('active');
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-recipes"] && !Shopify.designMode) return;
  try {
    
  var recipeText1 = document.getElementsByClassName('recipe-text-1')[0];
  var recipeText2 = document.getElementsByClassName('recipe-text-2')[0];
  var recipeImg1 = document.getElementsByClassName('recipe1-img')[0];
  var recipeImg2 = document.getElementsByClassName('recipe2-img')[0];
  var recipeImg1a = document.getElementsByClassName('recipe1-img')[1];
  var recipeImg2a = document.getElementsByClassName('recipe2-img')[1];

  var recipe1Btn = document.getElementsByClassName('recipe1btn')[0];
  var recipe2Btn = document.getElementsByClassName('recipe2btn')[0];

  var recipe1BtnMob = document.getElementsByClassName('recipe1btnmob')[0];
  var recipe2BtnMob = document.getElementsByClassName('recipe2btnmob')[0];

  recipeText1.style.display = 'block';
  recipeImg1.style.display = 'block';
  recipeImg1a.style.display = 'block';

  recipe1Btn.addEventListener('click', function () {
    recipe2Btn.classList.remove('btnactive');
    recipe1Btn.classList.add('btnactive');

    recipeText2.style.display = 'none';
    recipeImg2.style.display = 'none';
    recipeImg2a.style.display = 'none';

    recipeText1.style.display = 'block';
    recipeImg1.style.display = 'block';
    recipeImg1a.style.display = 'block';
  });

  recipe2Btn.addEventListener('click', function () {
    recipe1Btn.classList.remove('btnactive');
    recipe2Btn.classList.add('btnactive');

    recipeText1.style.display = 'none';
    recipeImg1.style.display = 'none';
    recipeImg1a.style.display = 'none';

    recipeText2.style.display = 'block';
    recipeImg2.style.display = 'block';
    recipeImg2a.style.display = 'block';
  });

  recipe1BtnMob.addEventListener('click', function () {
    recipe2BtnMob.classList.remove('btnactive');
    recipe1BtnMob.classList.add('btnactive');

    recipeText2.style.display = 'none';
    recipeImg2.style.display = 'none';
    recipeImg2a.style.display = 'none';

    recipeText1.style.display = 'block';
    recipeImg1.style.display = 'block';
    recipeImg1a.style.display = 'block';
  });

  recipe2BtnMob.addEventListener('click', function () {
    recipe1BtnMob.classList.remove('btnactive');
    recipe2BtnMob.classList.add('btnactive');

    recipeText1.style.display = 'none';
    recipeImg1.style.display = 'none';
    recipeImg1a.style.display = 'none';

    recipeText2.style.display = 'block';
    recipeImg2.style.display = 'block';
    recipeImg2a.style.display = 'block';
  });

  } catch(e) { console.error(e); }
})();
})();
